import { Box, FormControl, Select, InputLabel, MenuItem, TextField, Autocomplete } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { withTranslation, useTranslation } from "react-i18next";
import { isEqual, isEmpty } from "lodash";
import { useState } from 'react';

const DateCondition = (props) => {
  const { conditionList, period, maxDate, minDate, views, selectedSearch, setSelectedSearch, setPeriod, dateFormat, useAutoComplete, sx, openTo } = props;
  const { t } = useTranslation();
  const CURRENT_DATE = new ZDate();
  const MIN_DATE = new ZDate(CURRENT_DATE.getFullYear() - 10, 0, 1);
  const MAX_DATE = new ZDate(CURRENT_DATE.getFullYear() + 10, 0, 1);

  const [startClearTick, setStartClearTick] = useState(0);
  const [endClearTick, setEndClearTick] = useState(0);

  const onAccept = (value, type) => {
    if (type) {
      setPeriod({ ...period, [type]: value });
    }
  }

  const onChange = (value, type) => {
    if (!value) {
      setPeriod({ ...period, [type]: value });
    }
  }

  const monthYearChange = (e, type) => {
    const isDaySelect = views?.indexOf('day') === -1;
    const dateCopy = new Date(e);

    if (type && isDaySelect) {
      if (!useAutoComplete && type === "start") {
        dateCopy.setDate(1);
        dateCopy.setHours(0, 0, 0, 0);
      } else if (!useAutoComplete && type === "end") {
        const year = dateCopy.getFullYear();
        const month = dateCopy.getMonth();
        const lastDay = new Date(year, month + 1, 0).getDate();

        dateCopy.setDate(lastDay);
        dateCopy.setHours(23, 59, 59, 999);
      }
      setPeriod({ ...period, [type]: dateCopy });
    }
  }
  return (
    <Box size="small" sx={{ minWidth: "518px" }} >
      {conditionList && conditionList.length > 0 ? useAutoComplete ?
        <Autocomplete
          key={"periodSearchCondition"}
          options={conditionList}
          getOptionLabel={(option) => t(option.name)}
          value={selectedSearch}
          onChange={(_, newValue) => setSelectedSearch(newValue)}
          isOptionEqualToValue={(option, value) => {
            if (isEmpty(conditionList) || value === "") {
              return false;
            } else {
              return isEqual(option.cd, value.cd);
            }
          }}
          size="small"
          sx={{ display: "inline-flex", mr: 1, width: 195, ...sx }}
          renderInput={(params) => (
            <TextField {...params} label={t("periodSearchCondition")} />
          )}
        />
        :
        <FormControl sx={{ width: "190px", mr: 1, ...sx }}>
          <InputLabel>{t("periodSearchCondition")}</InputLabel>
          <Select
            id="periodSearchCondition"
            name="periodSearchCondition"
            size="small"
            value={selectedSearch}
            label={t("periodSearchCondition")}
            onChange={(event) => {
              setSelectedSearch(event.target.value);
            }}>
            {conditionList.map(condition => {
              return <MenuItem key={condition.cd} value={condition.name}>{t(condition.cd)}</MenuItem>
            })}
          </Select>
        </FormControl>
        : <Box></Box>}
      <LocalizationProvider dateAdapter={AdapterDateFns} >
        <DatePicker
          key={`start-${startClearTick}`}
          label={t("periodStart")}
          views={views ? views : ['year', 'month']}
          format={dateFormat ? dateFormat : 'yyyy-MM'}
          value={period.start}
          maxDate={period.end ? period.end : (maxDate ? maxDate : MAX_DATE)}
          minDate={minDate ? minDate : MIN_DATE}
          onAccept={(e) => onAccept(e, "start")}
          onChange={(e) => onChange(e, "start")}
          onMonthChange={(e) => monthYearChange(e, "start")}
          onYearChange={(e) => monthYearChange(e, "start")}
          slotProps={{ field: { 
            clearable: true,
            onClear: () => { 
              setStartClearTick((prev) => prev + 1);
            }
           }, textField: { size: "small", sx: { mr: 1, width: 180, ...sx } } }}
          openTo={openTo ? openTo : 'day'}
        />
        <DatePicker
          key={`end-${endClearTick}`}
          label={t("periodEnd")}
          views={views ? views : ['year', 'month']}
          format={dateFormat ? dateFormat : 'yyyy-MM'}
          value={period.end}
          maxDate={maxDate ? maxDate : MAX_DATE}
          minDate={period.start ? period.start : (minDate ? minDate : MIN_DATE)}
          onAccept={(e) => onAccept(e, "end")}
          onChange={(e) => onChange(e, "end")}
          onMonthChange={(e) => monthYearChange(e, "end")}
          onYearChange={(e) => monthYearChange(e, "end")}
          slotProps={{ field: { 
            clearable: true,
            onClear: () => { 
              setEndClearTick((prev) => prev + 1);
            }
           }, textField: { size: "small", sx: { mr: 1, width: 180, ...sx } } }}
          openTo={openTo ? openTo : 'day'}
        />
      </LocalizationProvider>
    </Box>
  )
}

export default withTranslation()(DateCondition);